import * as React from "react";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { NativeAd } from "components/utility/Ads/NativeAd";

interface GridViewProps {
  title: string;
  innerTitle: string;
  uci: string;
}

interface TitleProps {
  title: string;
}

const headingConfig: UitkHeadingProps = { tag: "h2", size: 3 };
const Title: React.FC<TitleProps> = ({ title }) => (
  <UitkSpacing padding={{ blockend: "three" }}>
    <UitkHeading {...headingConfig}>{title}</UitkHeading>
  </UitkSpacing>
);

export const MarqueeSingleCardView: React.FC<GridViewProps> = ({ title, innerTitle, uci }) => {
  return (
    <>
      {title && <Title title={title} />}
      {innerTitle && <Title title={innerTitle} />}
      <div className="meso-native-card-full-bleed">
        <NativeAd uci={uci} type="marquee" />
      </div>
    </>
  );
};
